module.exports = __webpack_public_path__ + "static/img/programme_atp.eb7e814.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_atp.jpg
// module id = BP2H
// module chunks = 0